import { Component, OnInit,TemplateRef, ViewChild } from '@angular/core';
import {MychampService} from '../services/mychamp.service'
import {MasterService} from '../services/master.service'
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  providers:[MychampService,MasterService]
})
export class NotificationComponent implements OnInit {
  dashslideimg:any[];
dashnotification:any[];
 dashtodo:any[];
 Myperformance:any[];
 Upcoming:any[];
 arrjobs:any=[];
 arrnotification:any=[];
 tag=0;
 ipactive:any;
 infodash:any={};
 closeResult: string;

  constructor(private mservice: MychampService,private msservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getactiveip();
    this.notifications('');
  }
  notifications(oprtype) {
    //var pstdata={jpid:jid,oprtype:oprtype};
    this.mservice.notifications(oprtype)
        .subscribe( 
        resultArray => {
            console.log('arrjobs', resultArray);
           this.arrnotification=resultArray.details;
this.infodash=resultArray.notinfocnt;
        },
        error => console.log("Error :: " + error)
        )
  }

  openlink(url:string){
  debugger
  let substr= 'http://';
  let substr1= 'https://';
 const result= url.indexOf(substr.toLowerCase());
 const result2= url.indexOf(substr1.toLowerCase());
var openurl="";
if(result!= -1 || result2!= -1)
{
   window.open(url);
}
else 
{
  window.open(substr+url);
}
 }

 openfiles(url:string){
  debugger
  window.open(this.ipactive+url);
 }

 getactiveip()
 {
   this.msservice.getipurl()
   .subscribe(
          resultArray =>{
  // this.liservice.Getdashboarddata('dashcounts')
     console.log('result-dashcounts',resultArray) ;
     this.ipactive=resultArray;
     
     //this.getprofiledata();

     },
    error => console.log('Error :: ' + error)
 );
 }
}
